import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface Settings {
  storeName: string
  storeAddress: string
  storePhone: string
  storeEmail: string
  currency: string
  currencySymbol: string
  taxRate: number
  timezone: string
  language: string
  receiptFooter: string
  receiptHeader: string
  autoBackup: boolean
  emailNotifications: boolean
  smsNotifications: boolean
  lowStockAlertEnabled: boolean
  lowStockThreshold: number
  barcodeScannerEnabled: boolean
  soundEnabled: boolean
  /** Session timeout in minutes (0 = disabled). Logs out after this period of inactivity. */
  sessionTimeoutMinutes: number
}

const DEFAULT_SETTINGS: Settings = {
  storeName: 'Sachin Poth Madura',
  storeAddress: '',
  storePhone: '',
  storeEmail: '',
  currency: 'LKR',
  currencySymbol: 'Rs.',
  taxRate: 0,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
  language: 'en',
  receiptFooter: 'Thank you for your purchase!',
  receiptHeader: 'Sachin Poth Madura',
  autoBackup: false,
  emailNotifications: true,
  smsNotifications: false,
  lowStockAlertEnabled: true,
  lowStockThreshold: 5,
  barcodeScannerEnabled: true,
  soundEnabled: true,
  sessionTimeoutMinutes: 30,
}

interface SettingsState {
  settings: Settings
  setSettings: (s: Partial<Settings>) => void
  resetSettings: () => void
  getSettings: () => Settings
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set, get) => ({
      settings: DEFAULT_SETTINGS,

      setSettings: (updates) =>
        set((state) => ({
          settings: { ...state.settings, ...updates },
        })),

      resetSettings: () => set({ settings: { ...DEFAULT_SETTINGS } }),

      getSettings: () => get().settings,
    }),
    { name: 'esales-pos-settings' }
  )
)
